import React from 'react'
import HeadCont from '../../components/common/HeadCont'

const Version = () => {
    const pleaseupdate = false;
  return (
    <>
      <HeadCont rightIcon={'no icon'} transparent={'on'} title={"App Version"} underline={true} />
      <section className='safe-area-mt-header mb-6 relative px-6 flex flex-col items-center  text-body1_700 text-gray_160'>
        <img src='/images/mobile/home/landing_rev.svg' alt={"Version"} className='pt-[94px]' />
        <span className='pt-[42px]'>{pleaseupdate ? "v1.0.0" : "v1.0.0"}</span>
        <span className='pt-4 pb-12'>{pleaseupdate ? "Update available" : "You're up to date!"}</span>
      </section>
    </>
  )
}

export default Version